// Central registry of admin-controllable Panchangam text roles. Each role can be
// styled from Admin → Panchangam Editor for Font + Size + Colour, and is applied
// via a `.pf-<role>` class (see index.css) on BOTH the Panchangam page and the
// homepage Panchangam strip. Extend here to expose new elements — nothing else
// needs to change in the admin UI.
export const PF_GROUPS = [
  {
    group: "Page header",
    roles: [
      { key: "hero_overline", label: "Eyebrow (DAILY ALMANAC)" },
      { key: "hero_title", label: "Page title (Panchangam)" },
      { key: "hero_subtitle", label: "Page description" },
      { key: "control_label", label: "Date / Time / Location labels" },
      { key: "date_heading", label: "Result date heading + Paksha badge" },
    ],
  },
  {
    group: "Cards (Vara, Tithi, Nakshatra…)",
    roles: [
      { key: "label", label: "Card label" },
      { key: "value", label: "Card value (main name)" },
      { key: "devata", label: "Devata line" },
      { key: "range", label: "Timespan / range pill" },
      { key: "next", label: "“Next …” line" },
      { key: "meta", label: "Small meta (Pada, Moon length…)" },
    ],
  },
  {
    group: "Current Hora",
    roles: [
      { key: "hora_title", label: "Hora name" },
      { key: "hora_meta", label: "Hora eyebrow / range / note" },
    ],
  },
  {
    group: "Windows & section headings",
    roles: [
      { key: "section_heading", label: "Section heading" },
      { key: "window_label", label: "Window / Choghadiya label" },
      { key: "window_time", label: "Window / Choghadiya time" },
      { key: "legend", label: "Legend chips" },
    ],
  },
  {
    group: "Special dates",
    roles: [
      { key: "special_title", label: "Special date · title" },
      { key: "special_note", label: "Special date · note" },
    ],
  },
  {
    group: "Custom sections",
    roles: [
      { key: "section_title", label: "Custom section · title" },
      { key: "section_body", label: "Custom section · body" },
    ],
  },
  {
    group: "Numbers & times",
    roles: [
      { key: "numbers", label: "All numerals, times & dates", numbers: true },
    ],
  },
];

export const PF_ROLES = PF_GROUPS.flatMap((g) => g.roles.map((r) => ({ ...r, group: g.group })));
export const PF_ROLE_KEYS = PF_ROLES.map((r) => r.key);
// role key "hero_overline" -> css class "pf-hero-overline"
export const pfClass = (key) => `pf-${key.replace(/_/g, "-")}`;
